import { Trans } from '@lingui/react/macro';
import { createFileRoute } from '@tanstack/react-router';

/**
 * Where an external participant lands if they wander off their study, or
 * anyone else reaches the external routes: the account only works through
 * the invitation link they were sent.
 */
export const Route = createFileRoute('/participants/_public/invite/only')({
  component: InviteOnlyPage,
});

function InviteOnlyPage() {
  return (
    <div className="mx-auto max-w-lg px-4 py-16 text-center">
      <h1 className="text-display-xs font-semibold text-primary">
        <Trans>Please use your invitation link</Trans>
      </h1>
      <p className="mt-3 text-md text-tertiary">
        <Trans>
          This page is only available through the study invitation you were
          sent. Open that link again to continue.
        </Trans>
      </p>
    </div>
  );
}
